module.exports = __webpack_public_path__ + "img/520-e7f7c4.png";